import { combineReducers } from '@reduxjs/toolkit';
import { envSlice } from 'store/env-slice';
import { projectsSlice } from 'app-entities/projects/projects-slice';
import { dataFromParentMicrofrontSlice } from 'store/data-from-parent-microfront-slice';
import { snackbarSlice } from './snakbar/snakbar-slice';

export const rootReducer = combineReducers({
  projects: projectsSlice.reducer,
  env: envSlice.reducer,
  dataFromParentMicrofront: dataFromParentMicrofrontSlice.reducer,
  snackbar: snackbarSlice.reducer,
});
